import { render, staticRenderFns } from "./valuationSummary.vue?vue&type=template&id=bd3fbd38&scoped=true"
import script from "./valuationSummary.vue?vue&type=script&lang=js"
export * from "./valuationSummary.vue?vue&type=script&lang=js"
import style0 from "./valuationSummary.vue?vue&type=style&index=0&id=bd3fbd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3fbd38",
  null
  
)

export default component.exports